import { MenuSearchResultBlockVariant } from '@as-react/common-types';
export const NOTHING_FOUND_SESSION_KEY = 'searchMade';
export const bannerIds = {
    [MenuSearchResultBlockVariant.SUGGESTIONS]: 'header-search-suggest-keyword',
    [MenuSearchResultBlockVariant.BRANDS]: 'header-search-suggest-brand',
    [MenuSearchResultBlockVariant.CATEGORIES]: 'header-search-suggest-category',
    [MenuSearchResultBlockVariant.BRAND_AS_CATEGORIES]: 'header-search-suggest-brand-as-category',
    [MenuSearchResultBlockVariant.CONTENT]: 'header-search-suggest-content',
};
export const blockTitles = {
    [MenuSearchResultBlockVariant.SUGGESTIONS]: 'flyout.title.searchsuggestions',
    [MenuSearchResultBlockVariant.BRANDS]: 'flyout.title.brands',
    [MenuSearchResultBlockVariant.CATEGORIES]: 'flyout.title.categories',
    [MenuSearchResultBlockVariant.BRAND_AS_CATEGORIES]: 'flyout.title.brand_as_categories',
    [MenuSearchResultBlockVariant.CONTENT]: 'flyout.title.relevant',
};
export const SEARCH_RESULT_LIMIT = {
    FOR_1_SEARCH_CHARACTER: 2,
    FOR_2_SEARCH_CHARACTER: 3,
    FOR_MORE_THEN_2_SEARCH_CHARACTER: 5,
    FOR_SEARCH_SUGGESTIONS: 7,
};
